/**
 * Fetch an image URL and return it as a File (for multipart API uploads).
 * Works for blob/data URLs and same-origin URLs; cross-origin URLs need CORS.
 *
 * Blob URLs are read via XHR first — extensions that wrap window.fetch often
 * break `fetch("blob:...")` with "TypeError: Failed to fetch".
 */

import { readBlobFromBlobUrl } from "./adoptBlobUrl";

export async function urlToFile(url, filename = "image.png", mimeType = "image/png") {
  if (!url || typeof url !== "string") {
    throw new Error("No valid image URL to upload.");
  }

  if (url.startsWith("blob:")) {
    const blob = await readBlobFromBlobUrl(url);
    const type = blob.type || mimeType;
    return new File([blob], filename, { type });
  }

  if (url.startsWith("data:")) {
    const res = await fetch(url);
    const blob = await res.blob();
    return new File([blob], filename, { type: blob.type || mimeType });
  }

  const res = await fetch(url, { mode: "cors" });
  if (!res.ok) {
    throw new Error(
      `Could not load image (${res.status}). If this is from S3, check CORS.`
    );
  }
  const blob = await res.blob();
  const type = blob.type || mimeType;
  return new File([blob], filename, { type });
}
